export enum ModuleEnum {
  Temperatures = "temperatures",
  MerchandiseReception = "merchandise_reception",
  Oils = "oils",
  Traceability = "traceability",
  Preparations = "preparations",
  Labels = "labels",
  Action = "actions",
  TemperatureControl = "temperature_control",
  Encyclopedia = "encyclopedia"
}
